import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Get all grid cards and extract hotel IDs
    const hotelIds = Array.from(
      this.element.querySelectorAll("[data-hotel-id]")
    ).map(card => card.getAttribute("data-hotel-id")).filter(Boolean);

    if (hotelIds.length === 0) return;

    // Parse search query parameters from the current URL
    const params = new URLSearchParams(window.location.search);

    const check_in = params.get("checkin");
    const check_out = params.get("checkout");
    if (!check_in || !check_out) return;

    // handle numeric and array params
    const adults = parseInt(params.get("adults") || "2", 10);
    const rooms = parseInt(params.get("rooms") || "1", 10);
    const childrens = parseInt(params.get("children") || "0", 10);
    const children_ages = [];
    params.forEach((value, key) => {
      if (/^child_age\[\d+\]$/.test(key) && value !== "") {
        const age = parseInt(value, 10);
        if (!isNaN(age)) {
          children_ages.push(age);
        }
      }
    });

    const payload = {
      check_in,
      check_out,
      adults,
      rooms,
      childrens,
      children_ages,
      hotel_ids: hotelIds
    };
    
    hotelIds.forEach(id => {
      const card = this.element.querySelector(`[data-hotel-id="${id}"]`);
      if (card) {
        card.querySelector("span.loading-icon").classList.remove("hidden");
        card.querySelector("div.price-section").classList.add("hidden")
      }
    });
    
    fetch("/api/v1/hotels/availability", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify(payload)
    })
      .then(async (resp) => {
        if (!resp.ok) {
          // Try to parse any error the backend sends
          let error;
          try {
            error = await resp.json();
          } catch {
            error = { message: "Something went wrong. Please try again." };
          }
          throw error;
        }
        return resp.json();
      })
      .then(data => {
        data.forEach(item => {
          const card = this.element.querySelector(`[data-hotel-id="${item.id}"]`);
          if (!card) return;
    
          // Update per night price
          const perNightEl = card.querySelector('span.pricePerDay');
          if (perNightEl && item.per_night) {
            perNightEl.textContent = parseInt(item.per_night, 10);
          }
    
          // Update total price
          const totalPriceEl = card.querySelector('span.totalPrice');
          if (totalPriceEl && item.price) {
            totalPriceEl.parentElement.classList.remove("hidden");
            totalPriceEl.dataset.originalPrice = item.price;
            totalPriceEl.textContent = parseInt(item.price, 10);
          }
        });
      })
      .catch(error => {
        // On error: ONLY remove loaders and revert to previous state, don't update any displayed values
        hotelIds.forEach(id => {
          const card = this.element.querySelector(`[data-hotel-id="${id}"]`);
          if (card) {
            card.querySelector("span.loading-icon").classList.add("hidden");
            card.querySelector("div.price-section").classList.remove("hidden");
            // Optional: Show error message (doesn't change price/values)
            // let errorEl = card.querySelector(".availability-error");
            // if (!errorEl) {
            //   errorEl = document.createElement("div");
            //   errorEl.className = "availability-error text-danger";
            //   card.appendChild(errorEl);
            // }
            // errorEl.textContent = error?.message || "Failed to get availability.";
          }
        });
      })
      .finally(() => {
        hotelIds.forEach(id => {
          const card = this.element.querySelector(`[data-hotel-id="${id}"]`);
          if (card) {
            // Remove loading icon and show price section
            card.querySelector("span.loading-icon").classList.add("hidden");
            card.querySelector("div.price-section").classList.remove("hidden");
          }
        });
        
        const event = new CustomEvent("currency:convert");
        window.dispatchEvent(event);
      });
  }
}
